import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center px-5 relative overflow-hidden">
      <div className="absolute inset-0 halftone-magenta opacity-20" />
      <div className="relative w-full max-w-md glass-chroma rounded-3xl p-8 md:p-10">
        <div className="w-14 h-14 rounded-full bg-[#ff0055]/20 grid place-items-center mb-6"><Lock className="text-[#ff0055]" /></div>
        <div className="font-mono2 text-xs tracking-[0.3em] text-[#00f0ff] uppercase mb-2">Restricted Access</div>
        <h1 className="font-display text-4xl uppercase mb-6">Admin Portal</h1>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <input data-testid="admin-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-[#08080c] border border-white/15 rounded-lg px-4 py-3 outline-none focus:border-[#00f0ff]" />
          <input data-testid="admin-password" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-[#08080c] border border-white/15 rounded-lg px-4 py-3 outline-none focus:border-[#00f0ff]" />
          {error && <div data-testid="admin-login-error" className="text-[#ff0055] font-head text-sm">{error}</div>}
          <button data-testid="admin-login-submit" disabled={loading} className="w-full bg-[#ff0055] text-white font-head font-bold uppercase py-3 rounded-full glow-magenta hover:scale-[1.02] transition-transform disabled:opacity-60 inline-flex items-center justify-center gap-2">
            {loading ? <Loader2 className="animate-spin" size={18} /> : null} Enter
          </button>
        </form>
      </div>
    </div>
  );
}
